import { Controller } from "@hotwired/stimulus"

// Shows each section only while the source field's value is one of the section's
// space-separated `data-show-for-value-values`. Hidden sections are disabled too (use a
// fieldset) so their fields don't post. A radio group can be the source by marking each
// radio as a source target; the checked one supplies the value.
export default class extends Controller {
  static targets = ["section", "source"]

  connect() {
    this.toggle()
  }

  toggle() {
    const value = this.sourceTargets.find((source) => source.type !== "radio" || source.checked)?.value

    this.sectionTargets.forEach((section) => {
      const shown = section.dataset.showForValueValues.split(/\s+/).includes(value)

      section.classList.toggle("hidden", !shown)
      section.disabled = !shown
    })
  }
}
